import { useEffect } from 'react';

const INTERACTION_EVENTS = [
  'pointerdown',
  'pointermove',
  'keydown',
  'touchstart',
  'scroll',
] as const;

/** Runs `callback` once, on the user's first interaction with the page. */
export function useFirstInteraction(callback: () => void) {
  useEffect(() => {
    let done = false;

    const run = () => {
      if (done) return;
      done = true;
      remove();
      callback();
    };

    const remove = () => {
      for (const event of INTERACTION_EVENTS) {
        window.removeEventListener(event, run);
      }
    };

    for (const event of INTERACTION_EVENTS) {
      window.addEventListener(event, run, { passive: true });
    }

    return remove;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
